import React from 'react';

import FullScreenError from './FullScreenError';

interface UncaughtErrorProps {
    error: Error;
    resetError: () => void;
}

const UncaughtError = ({ error, resetError }: UncaughtErrorProps) => {
    return <FullScreenError message={error.message} resetError={resetError} />;
};

export default UncaughtError;
